import { apiSlice } from '@/store/api/apiSlice';

export interface PredictionChartMeta {
  location: string;
  time: string;
}

export interface PredictionChart {
  chartId: string;
  chartType: 'north' | 'south';
  imageUrl: string;
  startDate: string;
  endDate: string;
  meta: PredictionChartMeta; 
}

export interface PredictionPeriodResponse {
  period: 'NextWeek' | 'NextMonth' | 'CurrentWeek' | 'CurrentMonth';
  startDate: string;
  endDate: string;
  charts: PredictionChart[];
}


export type PredictionPeriod =
  | 'NextWeek'
  | 'NextMonth'
  | 'CurrentWeek'
  | 'CurrentMonth';

export interface PredictionPeriodArgs {
  period: PredictionPeriod| string;
}

export const predictionPeriodApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getPredictionByPeriod: builder.query<
      PredictionPeriodResponse,
      PredictionPeriodArgs
    >({
      query: ({ period }) => ({
        url: 'predictions',
        method: 'GET',
        params: {
          period,
        },
      }),
    }),
  }),
});

export const {
  useGetPredictionByPeriodQuery,
  useLazyGetPredictionByPeriodQuery,
} = predictionPeriodApi;
